import Spouse from './Spouse';

export default class Client {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {number}
   */
  officeId;

  /**
   * @type {string}
   */
  stateId;

  /**
   * @type {string}
   */
  ssn;

  /**
   * @type {string}
   */
  firstName;

  /**
   * @type {string}
   */
  lastName;

  /**
   * @type {string}
   */
  city;

  /**
   * @type {string}
   */
  state;

  /**
   * @type {string}
   */
  zip;

  /**
   * @type {string}
   */
  email;

  /**
   * @type {string}
   */
  phone;

  /**
   * @type {boolean}
   */
  text_optin = true;

  /**
   * @type {string}
  */
 leadSource;

  /**
   * @type {string}
   */
  dateAdded;

  /**
   * @type {Client}
   */
  spouse;

  /**
   * @type {string}
   */
  rafCode;

  /**
   * @type {string}
   */
  officeEfin;

  /**
   * @type {string}
   */
  officeUserId;

  /**
   * @type {string}
   */
  ebEnrollmentDate;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.stateId != null) {
        this.stateId = opts.stateId;
      }
      if (opts.ssn != null) {
        this.ssn = opts.ssn;
      }
      if (opts.firstName != null) {
        this.firstName = opts.firstName;
      }
      if (opts.lastName != null) {
        this.lastName = opts.lastName;
      }
      if (opts.city != null) {
        this.city = opts.city;
      }
      if (opts.state != null) {
        this.state = opts.state;
      }
      if (opts.zip != null) {
        this.zip = opts.zip;
      }
      if (opts.email != null) {
        this.email = opts.email;
      }
      if (opts.phone != null) {
        this.phone = opts.phone;
      }
      if (opts.text_optin != null) {
        this.text_optin = opts.text_optin;
      }
      if (opts.leadSource != null) {
        this.leadSource = opts.leadSource;
      }
      if (opts.dateAdded != null) {
        this.dateAdded = opts.dateAdded;
      }
      if (opts.spouse != null) {
        this.spouse = new Spouse(opts.spouse);
      }
      if (opts.rafCode != null) {
        this.rafCode = opts.rafCode;
      }
      if (opts.officeEfin != null) {
        this.officeEfin = opts.officeEfin;
      }
      if (opts.officeUserId != null) {
        this.officeUserId = opts.officeUserId;
      }
      if (opts.ebEnrollmentDate != null) {
        this.ebEnrollmentDate = opts.ebEnrollmentDate;
      }
    }
  }
}
